import React, { useRef, useState } from "react";
import Box from "@amzn/meridian/box";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import Tooltip from "@amzn/meridian/tooltip";
import Icon from "@amzn/meridian/icon";
import Button from "@amzn/meridian/button";
import Menu, { MenuItem } from "@amzn/meridian/menu";
import infoKnockoutTokens from "@amzn/meridian-tokens/base/icon/info-knockout";
import menuMeatballTokens from "@amzn/meridian-tokens/base/icon/menu-meatball";
import Alert from "@amzn/meridian/alert";
import { FormattedMessage } from "react-intl";
import { useDispatch } from "react-redux";
import {
  deleteWidgetsFromDashboardConfig,
  saveDashboardConfiguration,
} from "../common/thunks/DashboardConfigurationDispatcher";
import {
  CONFIG_GROUP_TYPES,
  TOAST_NOTIFICATION_LEVELS,
  TOAST_MESSAGES,
  EDIT_PROPERTIES,
  DELETE,
} from "../constants/Constants";
import { useToastNotification } from "../common/context/ToastNotificationContext";

export default function WidgetHeader({
  title,
  description,
  widgetId,
  isEditMode = false,
  isInAlert = false,
  onEditClick,
  stationType,
  pageSelected,
  viewTypeSelected,
}) {
  const dispatch = useDispatch();
  const buttonRef = useRef();
  const [menuOpen, setMenuOpen] = useState(false);

  const { sendToastMessage } = useToastNotification();

  const onDeleteClick = async () => {
    sendToastMessage(
      "mySCC.toast.widgetDeleted",
      TOAST_MESSAGES.WIDGET_DELETED,
      TOAST_NOTIFICATION_LEVELS.SUCCESS,
    );

    // Delete the widget from config
    await dispatch(deleteWidgetsFromDashboardConfig(widgetId));

    // Immediately save the dashboard configuration
    if (stationType && pageSelected && viewTypeSelected) {
      dispatch(
        saveDashboardConfiguration(
          stationType,
          CONFIG_GROUP_TYPES.USER_ALIAS,
          pageSelected,
          viewTypeSelected,
        ),
      );
    }
  };

  // Dynamic widths array based on whether description and alert exist
  const widths = description ? ["fill", "fit", "fit"] : ["fill", "fit"];

  return (
    <Box>
      <Row alignmentVertical="center" spacing="medium" widths={widths}>
        {/* Title with optional alert icon - takes remaining space, truncates when needed */}
        <Box width="100%" minWidth={0}>
          <Row alignmentVertical="center" spacing="medium">
            <Text type="h300" truncate title={title}>
              {title}
            </Text>
            {isInAlert && <Alert type="warning" size="small"></Alert>}
          </Row>
        </Box>

        {/* Tooltip - fixed to content size, always visible if description exists */}
        {description && (
          <Box>
            <Tooltip position="right" title={description}>
              <Icon tokens={infoKnockoutTokens} />
            </Tooltip>
          </Box>
        )}

        {/* Menu - fixed to content size, always visible */}
        <Box>
          <Button
            ref={buttonRef}
            type="link"
            onClick={() => setMenuOpen(true)}
            size="small"
            disabled={!isEditMode}
            aria-haspopup="menu"
            aria-expanded={menuOpen}
          >
            <Icon tokens={menuMeatballTokens} color="secondary" />
          </Button>
          <Menu
            anchorNode={buttonRef.current}
            open={menuOpen}
            position="bottom"
            alignment="start"
            onClose={() => setMenuOpen(false)}
          >
            <MenuItem
              onClick={() => {
                onEditClick && onEditClick();
                setMenuOpen(false);
              }}
            >
              <Text>
                <FormattedMessage
                  id="mySCC.widgetHeader.editProperties"
                  defaultMessage={EDIT_PROPERTIES}
                />
              </Text>
            </MenuItem>
            <MenuItem
              onClick={() => {
                onDeleteClick();
                setMenuOpen(false);
              }}
            >
              <Text color="error">
                <FormattedMessage
                  id="mySCC.widgetHeader.delete"
                  defaultMessage={DELETE}
                />
              </Text>
            </MenuItem>
          </Menu>
        </Box>
      </Row>
    </Box>
  );
}



// WEBPACK FOOTER //
// ./src/components/mySCC/components/WidgetHeader.js